//扣缴申报确认
import { $http, buildHeaders } from "./index";

//获取算税列表
export const declareconfirm_list = (params) => {
  return $http.get("/admin/DeclareConfirm/index", { params });
};

//发送邀请
export const declareconfirm_send = (data) => {
  return $http.post("/admin/DeclareConfirm/invite", data, {
    headers: buildHeaders(3),
  });
};

//从税局更新数据
export const declareconfirm_pull = (data) => {
  return $http.post("/admin/DeclareConfirm/pull", data, {
    headers: buildHeaders(3),
  });
};

//获取操作记录
export const declareconfirm_log = (params) => {
  return $http.get("/admin/DeclareConfirm/log", {
    params,
    headers: buildHeaders(3),
  });
};

//导出
export const declareconfirm_export = (params) => {
  return $http.get("/admin/DeclareConfirm/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};
